module.exports = __webpack_public_path__ + "static/media/firedamage.7702e94b.jpg";